import Datatable from "components/Common/dataTable";
import UserProfileHeader from "components/Common/ui/UserProfileHeader";
import { useTranslation } from "react-i18next";
import React, { useEffect, useMemo, useState } from "react";
import { Alert, Tag } from "antd";
import { formatToLocaleDate } from "utils/dateUtils";
import ActionsDropdown, { Action } from "components/Common/ActionsDropdown";
import LeaveStatusBadge from "./LeaveStatusBadge";
import { showConfirmDialog } from "utils/confirmDialogUtils";

type Props = {
    dataSource: any[];
    loading?: boolean;
    onEdit: (record: any) => void;
    onDelete: (record: any) => void;
    dataPaginate: any;
    onChange: (pg: any) => void;
};
const MyLeaveTable: React.FC<Props> = ({ dataSource, loading, onEdit, onDelete, dataPaginate, onChange }) => {

    const handleDelete = (record: any) => {
        showConfirmDialog({
            title: t("leave.delete"),
            content: t("leave.delete_confirmation"),
            onOk: () => onDelete(record.id),
            okText: t("yes"),
            cancelText: t("no"),
            okType: "danger",
            loading: loading,
        });
    };
    // const defaultExpandedRowKeys = dataSource.filter((r: any) => r.status === "rejected")
    // .map((r: any) => r.id);

    const { t } = useTranslation();
    const columns = [
        {
            title: t("leave.form.leaveType"),
            dataIndex: ["leaveType", "name"],
            key: "leaveType",
            render: (_: any, r: any) => r.leaveType?.name || "—",
        },
        {
            title: t("leave.form.period"),
            dataIndex: "period",
            key: "period",
            render: (_: any, r: any) => t("leave.period." + r.period || "—"),
        },
        {
            title: t("leave.form.status"),
            dataIndex: "status",
            key: "status",
            align: "center" as const,
            render: (status: "pending" | "approved" | "rejected") => (
                <LeaveStatusBadge status={status} />
            ),
        },
        {
            title: t("leave.form.numberOfDays"),
            dataIndex: "numberOfDays",
            key: "numberOfDays",
            align: "center" as const,
            render: (_: any, r: any) => r.numberOfDays || "—",
        },
        {
            title: t("leave.form.startDate"),
            dataIndex: "startDate",
            key: "startDate",
            render: (v: string) => formatToLocaleDate(v) ?? "—",
        },
        {
            title: t("leave.form.endDate"),
            dataIndex: "endDate",
            key: "endDate",
            render: (v: string) => formatToLocaleDate(v) ?? "—",
        },
        {
            title: t("leave.form.createdAt"),
            dataIndex: "createdAt",
            key: "createdAt",
            render: (v: string) => formatToLocaleDate(v) ?? "—",
        },
        {
            title: t("actions"),
            key: "actions",
            render: (_: string, record: any) => {
                const actions: Action[] = [
                    {
                        label: t("edit"),
                        icon: "ti ti-edit",
                        actionType: "link",
                        hidden: record.status !== "pending",
                        onClick: () => onEdit(record),
                    },
                    {
                        label: t("delete"),
                        icon: "ti ti-trash",
                        actionType: "link",
                        hidden: record.status !== "pending",
                        onClick: () => handleDelete(record),
                    }
                ];
                return record.status === "pending" ? <ActionsDropdown actions={actions} /> : <i className="ti ti-lock"></i>;
            },
        },
    ];


    return (
        <div className="table-responsive">
            <Datatable
                rowKey="id"
                columns={columns}
                dataSource={dataSource}
                loading={loading}
                pagination={true}
                dataPaginate={dataPaginate}
                onChange={onChange}
                expandable={{
                    expandedRowRender: (record: any) =>
                        record.status === "rejected" ? (
                            <Alert
                                type="error"
                                showIcon
                                message={t("leave.form.reasonReject")}
                                description={
                                    <div
                                        style={{
                                            whiteSpace: "pre-wrap",
                                            wordBreak: "break-word",
                                            overflowWrap: "anywhere",
                                            marginTop: 4,
                                        }}
                                    >
                                        {record.reasonReject}
                                    </div>
                                }
                            />
                        ) : null,
                    rowExpandable: (record: any) => record.status === "rejected",
                    expandedRowClassName: () => "bg-transparent",


                }}
            // defaultExpandedRowKeys={defaultExpandedRowKeys}

            />
        </div>
    );
}
export default MyLeaveTable;

